import { defineStore } from 'pinia';
import { onRequestDefaultError, requests } from '🔗/utils/requests';

import { delay } from '🔗/utils/utils';

const useUserApi = defineStore('user-api', {
    state: () => ({
    }),
    actions: {
        async tglogin(data) {
            try {
                const result = await this.$http({
                    method: 'POST',
                    url: '/user/login/telegram',
                    data,
                    signal: requests.signal('login')
                });

                if ([200, 201].indexOf(result.status) !== -1) {
                    const { data } = result;

                    return data;
                } else {
                    onRequestDefaultError({ response: result });
                }
            } catch (e) {
                await delay(1500);

                onRequestDefaultError(e);
            }
        },

        async maxlogin(data) {
            try {
                const result = await this.$http({
                    method: 'POST',
                    url: '/user/login/max',
                    data,
                    signal: requests.signal('login')
                });

                if ([200, 201].indexOf(result.status) !== -1) {
                    const { data } = result;

                    return data;
                } else {
                    onRequestDefaultError({ response: result });
                }
            } catch (e) {
                await delay(1500);

                onRequestDefaultError(e);
            }
        },

        // My Profile
        async getMyProfile(data) {
            try {
                const result = await this.$http({
                    method: 'GET',
                    url: '/user/me',
                    signal: requests.signal('me')
                });
                if (result.status === 200) {
                    const { data } = result;

                    return data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },
        async updateMyProfile(data) {
            try {
                const result = await this.$http({
                    method: 'POST',
                    url: '/user/edit',
                    data,
                    signal: requests.signal('me-update')
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                } else {
                    onRequestDefaultError({ response: result });
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },
        async updateMyAvatar(file) {
            const formData = new FormData();
            formData.append('file', file);

            try {
                const result = await this.$http({
                    method: 'POST',
                    url: `/user/uploadAvatar`,
                    formData,
                    contentType: 'multipart/form-data',
                    signal: requests.signal('files-user-avatar')
                });

                if ([200, 201].indexOf(result.status) !== -1) {
                    return result.data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },

        // My items
        async getMyArtistsPreview() {
            if ([undefined, null].indexOf(this.myArtistsPreview) === -1) {
                return this.myArtistsPreview;
            }

            this.myArtistsPreview = await this.getMyArtists({ skip: 0, take: 4 });

            return this.myArtistsPreview;
        },
        async getMyArtists(params = {}) {
            try {
                const result = await this.$http({
                    method: 'GET',
                    url: '/user/artist',
                    params,
                    signal: requests.signal('my-artists')
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },
        async getMyPlaylists(params = {}) {
            try {
                const result = await this.$http({
                    method: 'GET',
                    url: '/user/playlists',
                    params,
                    signal: requests.signal('my-playlists')
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },

        // External Login
        async createExternalLogin() {
            try {
                const result = await this.$http({
                    method: 'GET',
                    url: '/user/externallogin',
                    signal: requests.signal('externallogin')
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },
        async checkExternalLogin(data) {
            try {
                const result = await this.$http({
                    method: 'POST',
                    url: '/user/externallogin/check',
                    data,
                    signal: requests.signal('externallogin-check')
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                }
            } catch (e) {
                // onRequestDefaultError(e);
            }
        },
        async authExternalLogin(data) {
            try {
                const result = await this.$http({
                    method: 'POST',
                    url: '/user/externallogin',
                    data,
                    signal: requests.signal('externallogin-auth')
                });

                if (result.status === 200) {
                    return true;
                }
            } catch (e) {
                // onRequestDefaultError(e);
            }
        },

        // Merge Accounts
        async createMergeRequest() {
            try {
                const result = await this.$http({
                    method: 'GET',
                    url: '/user/merge/request',
                    signal: requests.signal('merge-request')
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },
        async checkMergeRequest(data) {
            try {
                const result = await this.$http({
                    method: 'POST',
                    url: '/user/merge/check',
                    data,
                    signal: requests.signal('merge-request-check')
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                }
            } catch (e) {
                // onRequestDefaultError(e);
            }
        },
        async sendMergeRequest(data) {
            try {
                const result = await this.$http({
                    method: 'POST',
                    url: '/user/merge/request',
                    data,
                    signal: requests.signal('merge-request-send')
                });

                if (result.status === 200) {
                    return true;
                }
            } catch (e) {
                // onRequestDefaultError(e);
            }
        }
    }
});

export default useUserApi;
